import React from 'react'
import ReactDOM from 'react-dom'

const DeliveryStoreInfo = ({ store, data }) => {
    return <div className="happy-order__delivery-store-info">
        <div
            className="happy-order__delivery-store-title"
            dangerouslySetInnerHTML={ { __html : store.TITLE } }
        />

        <div
            className="happy-order__delivery-store-address"
            dangerouslySetInnerHTML={ { __html : store.ADDRESS } }
        />
        <div className="happy-order__delivery-store-schedule-title">
            Магазин работает:
        </div>
        <div
            className="happy-order__delivery-store-schedule-time"
            dangerouslySetInnerHTML={ { __html : store.SCHEDULE } }
        />
        <div
            className="happy-order__delivery-store-description"
            dangerouslySetInnerHTML={ { __html : store.DESCRIPTION } }
        />
    </div>
}

export default DeliveryStoreInfo